export enum RouteNames {
  watch = 'watch',
  formatProfile = 'format',
  playlistProfile = 'playlist',
  offer = 'offer',
  search = 'search',
  privacyPolicy = 'privacy-policy',
  dataProtectionPolicy = 'data-protection-policy',
  terms = 'terms',
  faq = 'faq',
  comingSoon = 'coming-soon',
  clubs = 'clubs',
  table = 'table',
  club = 'club',
}
